<template>
    <!--pc-->
  <div v-if="visitSource == 2 || visitSource == 3" class="operaButtonSet kw_btn_array_pc" :style="(tree?'margin:0':'')+(type=='updateButtonSet'?'justify-content: center;':'')+((type=='operaButtonSet'&&pageSetInfo.styleSet.operaButtonSetAll)?pageSetInfo.styleSet.operaButtonSetAll.styleSetCode:((type=='updateButtonSet'&&pageSetInfo.styleSet.updateButtonSetAll)?pageSetInfo.styleSet.updateButtonSetAll.styleSetCode:''))" :kwName="type=='operaButtonSet'?'operaButtonSetAll':'updateButtonSetAll'">
      <template v-for="(buttonItem,buttonIndex) in (type=='operaButtonSet'?pageSetInfo.operaButtonSet:(type=='updateButtonSet'?pageSetInfo.styleSet.updateButtonSet:pageSetInfo.buttonSet))">
          <template v-if="(!buttonItem.styleSet || buttonItem.styleSet.cssStyle!=2) && (showCssStyle == 0 || showCssStyle == ((buttonItem.styleSet&&buttonItem.styleSet.cssStyle)?buttonItem.styleSet.cssStyle:1))">
              <template v-if="(buttonItem.ifShow && (dataInfo[buttonItem.butTjKey] != 0 || type!='operaButtonSet'))">
                  <!-- 按钮外层 -->
                  <div :key="'button_'+buttonIndex" @click.stop="dataButtonClick(buttonItem,dataInfo)" :style="buttonItem.styleSet.buttonSetButtonStyleSet?buttonItem.styleSet.buttonSetButtonStyleSet.styleSetCode:''" kwName="buttonSetButtonStyleSet" :class="'buttonSetButtonStyleSet listButtonPc ' + (type=='updateButtonSet'?'updateButtonSetZdy':'') +(buttonItem.styleSet.cssBgPosition && buttonItem.styleSet.cssBgPosition==2?'positionBtn':'')">
                      <template :class="(buttonItem.styleSet.cssBgPosition==2?'positionBtnBox':'')+' '+(buttonItem.styleSet.imageShowHide ==1?'btnAndImage':'')">

                          <!-- 按钮背景图片   -->
                          <img v-if="(buttonItem.styleSet.imageBgShowHide!=2&&buttonItem.styleSet.btnBgImage)" class="buttonSetBgImageStyleSet joinCollectionBtnWithinPosition" :src="(GLOBAL.getFileServeUrl()+buttonItem.styleSet.btnBgImage)" :style="(buttonItem.styleSet.buttonSetBgImageStyleSet?buttonItem.styleSet.buttonSetBgImageStyleSet.styleSetCode:'') +'background-image:none;'" kwName="buttonSetBgImageStyleSet"/>
                          <!-- 按钮文本左侧图标或图片   -->
                          <img v-if="(buttonItem.styleSet.imageShowHide!=2 && buttonItem.styleSet.btnImage)" class="joinCollectionBtnWithin" :src="(GLOBAL.getFileServeUrl()+buttonItem.styleSet.btnImage)" :style="(buttonItem.styleSet.buttonSetImageStyleSet?buttonItem.styleSet.buttonSetImageStyleSet.styleSetCode:'') + 'background-image:none;'"/>

                          <div :style="buttonItem.styleSet.buttonSetFieldStyleSet?buttonItem.styleSet.buttonSetFieldStyleSet.styleSetCode:''" kwName="buttonSetFieldStyleSet" v-if="(!buttonItem.styleSet.fontHide || buttonItem.styleSet.fontHide!=2)" :class="'buttonSetFieldStyleSet simulationBtn '+(buttonItem.styleSet.imageBgShowHide==1?'simulationBtnPosition':'')">
                            {{buttonItem.buttonName}}</div>
                      </template>
                  </div>
              </template>
          </template>
      </template>
      <el-dialog class="zdy_dialog" v-if="dialogInfo.ifLoad" :visible.sync="dialogInfo.ifLoad" width="90%" top="1vh" center append-to-body :close-on-click-modal="false" v-dialogDrag>
        <template slot="title"> 
            <div>
              {{(dialogInfo.pageInfo&&dialogInfo.pageInfo.menuName)?dialogInfo.pageInfo.menuName:'弹出层'}}
            </div>    
        </template>
        <kw_list v-if="dialogInfo.type==1" ref="kw_list_dialog" :initPageObj="dialogInfo.pageInfo" :isLimitButton="isLimitButton" :ifDialog="1"></kw_list>
        <kw_look v-else-if="dialogInfo.type==11" ref="kw_look_dialog" :pageInfo="dialogInfo.pageInfo" @goBack="dialogIframeZdyCancel" :isLimitButton="isLimitButton" :ifDialog="1"></kw_look>
        <iframe v-else-if="dialogInfo.type==999" ref="dialog999" :style="'width:100%;height:' + (windowHeight-70) + 'px;'" frameborder=0 name="showHere" scrolling=auto  :src="dialogInfo.url" ></iframe>
        <span slot="footer" v-if="dialogInfo.type==999">
          <el-button @click="dialogIframeZdyCancel">取 消</el-button>
          <el-button type="primary" @click="dialogIframeZdyConfirm">确 定</el-button>
        </span>
      </el-dialog>
  </div>


    <!--h5-->
  <div v-else class="kw_btn_array" :style="(tree?'margin:0':'')">
      <div v-for="(buttonItem,buttonIndex) in (type=='operaButtonSet'?pageSetInfo.operaButtonSet:pageSetInfo.buttonSet)" :key="'button_'+buttonIndex">
        <div v-if="(buttonItem.styleSet.cssStyle!=2)">
          <div v-if="(buttonItem.ifShow && (dataInfo[buttonItem.butTjKey] != 0 || type!='operaButtonSet'))">
            <!-- 按钮外层 -->
            <div @click.stop="dataButtonClick(buttonItem,dataInfo)" :style="buttonItem.styleSet.buttonSetButtonStyleSet?buttonItem.styleSet.buttonSetButtonStyleSet.styleSetCode:''" kwName="buttonSetButtonStyleSet" :class="'listButton '+(buttonItem.styleSet.cssBgPosition && buttonItem.styleSet.cssBgPosition==2?'positionBtn':'')">
            <div :class="(buttonItem.styleSet.cssBgPosition==2?'positionBtnBox':'')+' '+(buttonItem.styleSet.imageShowHide ==1?'btnAndImage':'')">

                <!-- 按钮背景图片   -->
                <img v-if="(buttonItem.styleSet.imageBgShowHide!=2&&buttonItem.styleSet.btnBgImage)" class="joinCollectionBtnWithinPosition" :src="(GLOBAL.getFileServeUrl()+buttonItem.styleSet.btnBgImage)" :style="(buttonItem.styleSet.buttonSetBgImageStyleSet?buttonItem.styleSet.buttonSetBgImageStyleSet.styleSetCode:'') +'background-image:none;'" kwName="buttonSetBgImageStyleSet"/>
                <!-- 按钮文本左侧图标或图片   -->
                <img v-if="(buttonItem.styleSet.imageShowHide!=2 && buttonItem.styleSet.btnImage)" class="joinCollectionBtnWithin" :src="(GLOBAL.getFileServeUrl()+buttonItem.styleSet.btnImage)" :style="(buttonItem.styleSet.buttonSetImageStyleSet?buttonItem.styleSet.buttonSetImageStyleSet.styleSetCode:'') + 'background-image:none;'"/>

                <div :style="buttonItem.styleSet.buttonSetFieldStyleSet?buttonItem.styleSet.buttonSetFieldStyleSet.styleSetCode:''" kwName="buttonSetFieldStyleSet" v-if="(!buttonItem.styleSet.fontHide || buttonItem.styleSet.fontHide!=2)" :class="'simulationBtn '+(buttonItem.styleSet.imageBgShowHide==1?'simulationBtnPosition':'')">{{buttonItem.buttonName}}</div>
                </div>

            </div>


          </div>
        </div>
      </div>
  </div>
  
</template>

<script>
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';

export default {
  name: 'kw_btn_array',
  props: {
    pageSetInfo: {
      type: Object,
      default: null
    },
    dataInfo:{
      type: Object,
      default: function(){
				return {};
			}
    },
    dataIndex:{
      type:Number,
      default:0
    },
    tree:{
      type: String,
      default: ''
    },
    type:{
      type : String,
      default:'operaButtonSet'
    } ,
    previewVisitSource:{
      type:Number,
      default:0
    },
    //按钮是否根据角色权限限制
    isLimitButton:{
      type: Boolean,
      default: false
    },
    //显示的按钮样式
    showCssStyle:{
      type:Number,
      default:0
    }
  },
  data() {
    var that = this;
    return {
      // 访问来源 PC:2 或者 H5:3
      visitSource:utils.checkVisitSource(that),
      /**
       * 弹出层组件的信息
       */
      dialogInfo:{
        ifLoad:false
      },
    };
  },
  created() {
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
    kw_look:resolve => require(['@/components/look/kw_look.vue'], resolve),
    kw_list:resolve => require(['@/components/list/kw_list.vue'], resolve)
  },
  methods: {
    /**
     * 按钮点击事件
     */
    dataButtonClick(buttonOne,dataInfo){
      // console.log("按钮组件中的点击事件",e);
      this.$emit("dataButtonClick",buttonOne,dataInfo,this.dataIndex);
    },
    /**
     * 弹出层打开iframe时的确定按钮
     */
    dialogIframeZdyConfirm(){
      var that = this;
      that.$refs.dialog999.contentWindow.closeDialogFun=function(){
        that.dialogInfo.ifLoad = false;
      };
      that.$refs.dialog999.contentWindow.saveZdyPage();
    },
    /**
     * 弹出层打开iframe时的取消按钮
     */
    dialogIframeZdyCancel(ifRefresh){
      var that = this;
      this.dialogInfo.ifLoad = false;
      if(ifRefresh == 1) {
        this.refreshevent();
      }
    },
    refreshevent() {
      this.$emit("refreshevent");
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.kw_btn_array{display: flex;align-items: center;margin: 5px 0}
.kw_btn_array_pc{display: flex;align-items: center;}
.listButton{font-size: 14px;width: 100px;height: 30px;line-height: 30px;border-radius: 30px;display: inline-block;text-align: center;/* padding-left: 15px */}
.listButtonPc{font-size: 14px;display: inline-block;text-align: center;vertical-align: middle;color: #FFF;background-color: #409EFF;border-color: #409EFF;border: 1px solid #DCDFE6;padding: 6px 10px;border-radius: 4px;}
.updateButtonSetZdy{margin: 0 20px 10px 0;width: 80px;}
.positionBtnBox{position: relative;}
.positionBtn{position: absolute;bottom: 0;right: 0}
.btnAndImage{display: flex;align-items: center}

.simulationBtn{text-align: center;font-size: 14px;display: inline-block;}
.simulationBtnPosition{position: absolute;left: 22px;}
.joinCollectionBtnWithinPosition{position: absolute;left: 0;top: 0;background-size: 100% 100%;width: 100px;height: 30px}
.joinCollectionBtnWithin{width: 30px;height: 30px;vertical-align: middle;margin:0 5px}

.basicCard_0 .buttonSetFieldStyleSet{
  width:max-content;
}
.basicCard_0 .operaButtonSet{
  width:100%;
  overflow-y: scroll;
}
 
</style>
